import React, { useEffect, useState } from 'react';
import 'rc-banner-anim/assets/index.css';
import { Button, Col, Flex, Row } from 'antd';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { useTranslation } from 'react-i18next';

const Content3 = (props) => {
  const { dataSource, isMobile, ...restProps } = props;
  const { t } = useTranslation();
  const { titleWrapper, page, childWrapper } = dataSource;

  const settings = {
    dots: true, //是否显示底部的点状导航
    // infinite: true, //是否开启无限循环的轮播
    // speed: 3000, //幻灯片切换动画的速度
    slidesToShow: isMobile ? 1 : 3, //每次显示的幻灯片数量
    slidesToScroll: 1, //每次滑动时移动的幻灯片数量
    autoplay: true, //是否开启自动播放
    autoplaySpeed: 3000 // 自动播放速度，单位毫秒
  };
  const ChildWrapper = ({ item, content }) => (
    <div {...item}>
      <div {...content}>
        <img src={require('@/assets/production/eLearn/' + content.children.img)} />
        <h2>{t(content.children.title)}</h2>
        <ul>
          {content.children.children.map((c, j) => (
            <li key={j.toString()}>
              <span>{t(c.title)}</span>
              <span dangerouslySetInnerHTML={{ __html: t(c.children) }}></span>
            </li>
          ))}
        </ul>
      </div>

    </div>
  );
  return (
    <div {...restProps} {...dataSource.wrapper}>
      <div {...page}>
        <div key="content3">
          <div {...titleWrapper}>
            <h1 {...titleWrapper.children[0]}>
              {t(titleWrapper.children[0].children)}
            </h1>
            <h2 {...titleWrapper.children[1]}>
              {titleWrapper.children[1].children}
            </h2>
          </div>

          <Slider {...settings}>
            {childWrapper.children.map((content, i) => (
              <ChildWrapper key={i.toString()} item={childWrapper} content={content} />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Content3;
